import PackagesCarouselContainer from '../../../../components/containers/PackagesCarouselContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFaresPackageCarousel';

const cmpConfig = {
  name: 'packages-carousel',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PackagesCarouselContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
